import { render, staticRenderFns } from "./alarmData.vue?vue&type=template&id=62f531ae&scoped=true&"
import script from "./alarmData.vue?vue&type=script&lang=js&"
export * from "./alarmData.vue?vue&type=script&lang=js&"
import style0 from "./alarmData.vue?vue&type=style&index=0&id=62f531ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f531ae",
  null
  
)

export default component.exports